import {getGlobalParameter} from "../model";
import {stores} from "../stores";

function checkCondition(condition: any) {
    let param = getGlobalParameter(condition.param);
    if (param) {
        let value = stores.memory.getValue(param);
        let op = condition.op ?? "eq";
        // console.log("param.conditions", cond.value, op, condParamValue);
        switch (op.toLowerCase()) {
            case "eq":
                if (value !== condition.value) {
                    return false;
                }
                break;
            case "ne":
                if (value === condition.value) { // was implemented but not documented
                    return false;
                }
                break;
            case "gt":
                if (value <= condition.value) {
                    return false;
                }
                break;
            case "lt":
                if (value >= condition.value) { // added MIF, was documented but not implemented
                    return false;
                }
                break;
            default:
                console.warn("condition param operator not supported ", condition)
        }
    } else {
        console.warn("condition param not found", condition);
    }
    return true;
}

export function conditionsOk(item: any): boolean {
    if ("condition" in item) {
        console.log("Checking single condition:", item.condition);
        if (!checkCondition(item.condition)) {
            return false;
        }
    }
    if ("conditions" in item) {
        console.log("Checking multiple conditions:", item.conditions);
        for (let cond of item.conditions) {
            if (!checkCondition(cond)) {
                return false;
            }
        }
    }
    return true;
}